import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/sl'

dayjs.extend(relativeTime)

// formatDateTime renders an ISO timestamp as a compact local date-time, or an
// em dash when the value is missing (e.g. an instance that never checked in).
export const formatDateTime = (value?: string | null): string => {
    if (!value) return '—'
    return dayjs(value).format('DD.MM.YYYY HH:mm')
}

export const fromNow = (value?: string | null): string => {
    if (!value) return '—'
    return dayjs(value).fromNow()
}

// isZeroDate reports whether a timestamp is Go's zero time, which is what an
// unset time.Time serialises to ("0001-01-01T00:00:00Z"). The API sends those
// for "never happened" fields, and they must render as absent, not as a date in
// the year 1.
export const isZeroDate = (value?: string | null): boolean => {
    if (!value) return true
    return value.startsWith('0001-01-01')
}

// formatDate renders an ISO timestamp as a date only. Used where the time of day
// carries no meaning — most of all the grace-period deadline, which is a day the
// customer has to act by, not a minute.
export const formatDate = (value?: string | null): string => {
    if (!value || isZeroDate(value)) return '—'
    return dayjs(value).format('DD.MM.YYYY')
}
